import useQueryParams from 'hooks/query/queryParams'

const useFileParams = (): number | null => {
  const query = useQueryParams()
  return Number(query.get('entryId')) || null
}

export default useFileParams
